import type { SVGProps } from "react";

interface IconProps extends SVGProps<SVGSVGElement> {
  fill?: string;
  isActive?: boolean;
}

const ProgramNoData = ({
  fill = "#6F747B",
  isActive,
  ...restProps
}: IconProps) => (
  <svg
    width="120"
    height="109"
    viewBox="0 0 120 109"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_6535_1113288"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="25"
      y="0"
      width="71"
      height="71"
    >
      <path d="M25 -7.62939e-06H96V71H25V-7.62939e-06Z" fill="white" />
    </mask>
    <g mask="url(#mask0_6535_1113288)">
      <path
        d="M94.6836 18.1738H26.3184"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.962 32.7207V10.8194C94.962 10.0537 94.3411 9.4327 93.5752 9.4327H77.8184"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.5918 61.5703H93.5727C94.3386 61.5703 94.9594 60.9495 94.9594 60.1836V37.5087"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.03 9.43343H27.4277C26.6618 9.43343 26.041 10.0543 26.041 10.8201V60.1836C26.041 60.9495 26.6618 61.5703 27.4277 61.5703H82.8059"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.5781 13.8027H31.5954"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.7168 13.8027H34.7341"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8594 13.8027H37.8766"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M87.4863 13.8027H89.4216"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.5666 33.3495C70.5666 38.9079 66.0604 43.4141 60.502 43.4141C54.9435 43.4141 50.4375 38.9079 50.4375 33.3495C50.4375 27.791 54.9435 23.285 60.502 23.285C66.0604 23.285 70.5666 27.791 70.5666 33.3495Z"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.8281 46.8984H64.1729"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.4808 53.9453H43.4863"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.5163 53.9453H73.7051"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.7894 57.1094H43.4863"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M77.5163 57.1094H55.7363"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.3809 30.233L63.6205 36.4727"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.6205 30.233L57.3809 36.4727"
        stroke="#2C3236"
        className="dark:stroke-caption"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M3.22425 103V91.8H4.63225L9.59225 99.768C9.67225 99.9013 9.74958 100.035 9.82425 100.168C9.89892 100.301 9.97625 100.445 10.0563 100.6C10.0509 100.461 10.0429 100.323 10.0323 100.184C10.0269 100.045 10.0243 99.912 10.0243 99.784V91.8H11.4163V103H10.0723L5.03225 95C4.96292 94.8773 4.88825 94.7493 4.80825 94.616C4.73358 94.4827 4.65892 94.3493 4.58425 94.216C4.59492 94.3333 4.60292 94.4613 4.60825 94.6C4.61358 94.7387 4.61625 94.872 4.61625 95V103H3.22425ZM17.4796 103.192C16.3596 103.192 15.477 102.811 14.8316 102.048C14.1863 101.28 13.8636 100.237 13.8636 98.92C13.8636 98.04 14.0103 97.28 14.3036 96.64C14.597 96 15.013 95.5067 15.5516 95.16C16.0956 94.808 16.7383 94.632 17.4796 94.632C18.2263 94.632 18.869 94.8053 19.4076 95.152C19.9516 95.4933 20.3676 95.984 20.6556 96.624C20.949 97.264 21.0956 98.024 21.0956 98.904C21.0956 99.784 20.949 100.547 20.6556 101.192C20.3623 101.832 19.9436 102.325 19.3996 102.672C18.861 103.019 18.221 103.192 17.4796 103.192ZM17.4796 101.896C18.1676 101.896 18.7063 101.632 19.0956 101.104C19.4903 100.571 19.6876 99.8373 19.6876 98.904C19.6876 97.9653 19.4903 97.232 19.0956 96.704C18.7063 96.176 18.1676 95.912 17.4796 95.912C16.7863 95.912 16.245 96.176 15.8556 96.704C15.4663 97.2267 15.2716 97.9653 15.2716 98.92C15.2716 99.8533 15.4663 100.584 15.8556 101.112C16.245 101.635 16.7863 101.896 17.4796 101.896ZM27.2711 103V91.8H30.3271C31.2871 91.8 32.0978 91.96 32.7591 92.28C33.4258 92.6 33.9618 93.0293 34.3671 93.568C34.7725 94.1013 35.0658 94.7013 35.2471 95.368C35.4338 96.0293 35.5271 96.7067 35.5271 97.4C35.5271 98.0453 35.4418 98.696 35.2711 99.352C35.1005 100.008 34.8151 100.613 34.4151 101.168C34.0205 101.717 33.4845 102.16 32.8071 102.496C32.1298 102.832 31.2818 103 30.2631 103H27.2711ZM28.6631 101.704H30.4391C31.1378 101.704 31.7191 101.579 32.1831 101.328C32.6525 101.072 33.0258 100.736 33.3031 100.32C33.5858 99.8987 33.7858 99.4347 33.9031 98.928C34.0258 98.416 34.0871 97.9067 34.0871 97.4C34.0871 96.856 34.0205 96.328 33.8871 95.816C33.7591 95.2987 33.5538 94.8347 33.2711 94.424C32.9938 94.0133 32.6365 93.688 32.1991 93.448C31.7618 93.2027 31.2338 93.08 30.6151 93.08H28.6631V101.704ZM40.0241 103.192C39.1388 103.192 38.4428 102.947 37.9361 102.456C37.4295 101.965 37.1761 101.293 37.1761 100.44C37.1761 99.8907 37.3015 99.4133 37.5521 99.008C37.8028 98.6027 38.1575 98.2907 38.6161 98.072C39.0748 97.848 39.6135 97.736 40.2321 97.736C40.6321 97.736 41.0055 97.7813 41.3521 97.872C41.7041 97.9573 42.0348 98.088 42.3441 98.264V97.688C42.3441 97.0533 42.2001 96.5893 41.9121 96.296C41.6241 95.9973 41.1761 95.848 40.5681 95.848C40.1788 95.848 39.7735 95.92 39.3521 96.064C38.9361 96.208 38.5468 96.408 38.1841 96.664L37.7841 95.496C38.1948 95.224 38.6615 95.0133 39.1841 94.864C39.7121 94.7093 40.2321 94.632 40.7441 94.632C41.7148 94.632 42.4428 94.88 42.9281 95.376C43.4135 95.8667 43.6561 96.6 43.6561 97.576V103H42.3441V102.248C42.0241 102.552 41.6641 102.787 41.2641 102.952C40.8641 103.112 40.4508 103.192 40.0241 103.192ZM40.2321 101.976C40.6108 101.976 40.9841 101.883 41.3521 101.696C41.7255 101.509 42.0561 101.245 42.3441 100.904V99.496C42.0721 99.3253 41.7628 99.192 41.4161 99.096C41.0695 99 40.7388 98.952 40.4241 98.952C39.8268 98.952 39.3548 99.088 39.0081 99.36C38.6615 99.6267 38.4881 99.992 38.4881 100.456C38.4881 100.925 38.6428 101.296 38.9521 101.568C39.2615 101.84 39.6881 101.976 40.2321 101.976ZM48.1156 103.192C47.5556 103.192 47.1263 103.024 46.8276 102.688C46.5343 102.352 46.3876 101.869 46.3876 101.24V96.04H45.0596V94.824H46.3876V92.12L47.7796 91.448V94.824H49.7956V96.04H47.7796V100.776C47.7796 101.165 47.8463 101.451 47.9796 101.632C48.1183 101.808 48.3343 101.896 48.6276 101.896C49.001 101.896 49.4063 101.752 49.8436 101.464L49.6836 102.824C49.4436 102.952 49.193 103.045 48.9316 103.104C48.6756 103.163 48.4036 103.192 48.1156 103.192ZM54.1023 103.192C53.2169 103.192 52.5209 102.947 52.0143 102.456C51.5076 101.965 51.2543 101.293 51.2543 100.44C51.2543 99.8907 51.3796 99.4133 51.6303 99.008C51.8809 98.6027 52.2356 98.2907 52.6943 98.072C53.1529 97.848 53.6916 97.736 54.3103 97.736C54.7103 97.736 55.0836 97.7813 55.4303 97.872C55.7823 97.9573 56.1129 98.088 56.4223 98.264V97.688C56.4223 97.0533 56.2783 96.5893 55.9903 96.296C55.7023 95.9973 55.2543 95.848 54.6463 95.848C54.2569 95.848 53.8516 95.92 53.4303 96.064C53.0143 96.208 52.6249 96.408 52.2623 96.664L51.8623 95.496C52.2729 95.224 52.7396 95.0133 53.2623 94.864C53.7903 94.7093 54.3103 94.632 54.8223 94.632C55.7929 94.632 56.5209 94.88 57.0063 95.376C57.4916 95.8667 57.7343 96.6 57.7343 97.576V103H56.4223V102.248C56.1023 102.552 55.7423 102.787 55.3423 102.952C54.9423 103.112 54.5289 103.192 54.1023 103.192ZM54.3103 101.976C54.6889 101.976 55.0623 101.883 55.4303 101.696C55.8036 101.509 56.1343 101.245 56.4223 100.904V99.496C56.1503 99.3253 55.8409 99.192 55.4943 99.096C55.1476 99 54.8169 98.952 54.5023 98.952C53.9049 98.952 53.4329 99.088 53.0863 99.36C52.7396 99.6267 52.5663 99.992 52.5663 100.456C52.5663 100.925 52.7209 101.296 53.0303 101.568C53.3396 101.84 53.7663 101.976 54.3103 101.976ZM62.7691 103L66.7371 91.8H68.0331L72.0011 103H70.5771L69.6171 100.264H65.1691L64.2251 103H62.7691ZM65.5851 99.032H69.1851L67.7451 94.888C67.7078 94.7813 67.6651 94.6587 67.6171 94.52C67.5745 94.376 67.5318 94.2373 67.4891 94.104C67.4465 93.9653 67.4145 93.848 67.3931 93.752C67.3665 93.848 67.3318 93.9653 67.2891 94.104C67.2518 94.2373 67.2091 94.376 67.1611 94.52C67.1185 94.6587 67.0785 94.7813 67.0411 94.888L65.5851 99.032ZM75.5276 103L72.5356 94.824H73.9436L75.8796 100.28C75.9276 100.413 75.973 100.544 76.0156 100.672C76.0583 100.8 76.0983 100.936 76.1356 101.08C76.1783 100.936 76.2183 100.8 76.2556 100.672C76.2983 100.544 76.3436 100.413 76.3916 100.28L78.2956 94.824H79.6876L76.6956 103H75.5276ZM83.5866 103.192C82.7013 103.192 82.0053 102.947 81.4986 102.456C80.992 101.965 80.7386 101.293 80.7386 100.44C80.7386 99.8907 80.864 99.4133 81.1146 99.008C81.3653 98.6027 81.72 98.2907 82.1786 98.072C82.6373 97.848 83.176 97.736 83.7946 97.736C84.1946 97.736 84.568 97.7813 84.9146 97.872C85.2666 97.9573 85.5973 98.088 85.9066 98.264V97.688C85.9066 97.0533 85.7626 96.5893 85.4746 96.296C85.1866 95.9973 84.7386 95.848 84.1306 95.848C83.7413 95.848 83.336 95.92 82.9146 96.064C82.4986 96.208 82.1093 96.408 81.7466 96.664L81.3466 95.496C81.7573 95.224 82.224 95.0133 82.7466 94.864C83.2746 94.7093 83.7946 94.632 84.3066 94.632C85.2773 94.632 86.0053 94.88 86.4906 95.376C86.976 95.8667 87.2186 96.6 87.2186 97.576V103H85.9066V102.248C85.5866 102.552 85.2266 102.787 84.8266 102.952C84.4266 103.112 84.0133 103.192 83.5866 103.192ZM83.7946 101.976C84.1733 101.976 84.5466 101.883 84.9146 101.696C85.288 101.509 85.6186 101.245 85.9066 100.904V99.496C85.6346 99.3253 85.3253 99.192 84.9786 99.096C84.632 99 84.3013 98.952 83.9866 98.952C83.3893 98.952 82.9173 99.088 82.5706 99.36C82.224 99.6267 82.0506 99.992 82.0506 100.456C82.0506 100.925 82.2053 101.296 82.5146 101.568C82.824 101.84 83.2506 101.976 83.7946 101.976ZM89.6565 103V94.824H91.0485V103H89.6565ZM90.3445 93.336C90.1045 93.336 89.8992 93.2533 89.7285 93.088C89.5632 92.9173 89.4805 92.712 89.4805 92.472C89.4805 92.2213 89.5632 92.0107 89.7285 91.84C89.8992 91.664 90.1045 91.576 90.3445 91.576C90.5952 91.576 90.8032 91.664 90.9685 91.84C91.1392 92.0107 91.2245 92.2213 91.2245 92.472C91.2245 92.712 91.1392 92.9173 90.9685 93.088C90.8032 93.2533 90.5952 93.336 90.3445 93.336ZM93.783 103V92.104L95.175 91.448V103H93.783ZM101.379 103.192C100.973 103.192 100.605 103.12 100.275 102.976C99.9438 102.832 99.6132 102.605 99.2825 102.296V103H97.8905V92.104L99.2825 91.448V95.528C99.5385 95.2453 99.8452 95.0267 100.203 94.872C100.565 94.712 100.941 94.632 101.331 94.632C102.024 94.632 102.624 94.8053 103.131 95.152C103.637 95.4987 104.029 95.992 104.307 96.632C104.584 97.272 104.723 98.0293 104.723 98.904C104.723 100.264 104.429 101.32 103.843 102.072C103.256 102.819 102.435 103.192 101.379 103.192ZM101.187 101.896C101.869 101.896 102.392 101.637 102.755 101.12C103.117 100.603 103.299 99.864 103.299 98.904C103.299 97.928 103.117 97.1867 102.755 96.68C102.397 96.168 101.875 95.912 101.187 95.912C100.819 95.912 100.456 96.016 100.099 96.224C99.7412 96.4267 99.4692 96.6853 99.2825 97V100.792C99.4852 101.128 99.7545 101.397 100.091 101.6C100.432 101.797 100.797 101.896 101.187 101.896ZM106.955 103V92.104L108.347 91.448V103H106.955ZM114.214 103.192C113.468 103.192 112.822 103.008 112.278 102.64C111.734 102.272 111.316 101.765 111.022 101.12C110.729 100.475 110.582 99.736 110.582 98.904C110.582 98.0027 110.734 97.2347 111.038 96.6C111.342 95.96 111.766 95.472 112.31 95.136C112.854 94.8 113.489 94.632 114.214 94.632C114.828 94.632 115.39 94.7707 115.902 95.048C116.414 95.32 116.822 95.744 117.126 96.32C117.436 96.8907 117.59 97.624 117.59 98.52C117.59 98.648 117.585 98.7973 117.574 98.968C117.569 99.1333 117.558 99.304 117.542 99.48H112.006C112.06 99.976 112.182 100.411 112.374 100.784C112.566 101.157 112.82 101.451 113.134 101.664C113.449 101.872 113.82 101.976 114.246 101.976C114.593 101.976 114.913 101.915 115.206 101.792C115.505 101.669 115.782 101.48 116.038 101.224L116.854 102.136C116.55 102.44 116.172 102.693 115.718 102.896C115.27 103.093 114.769 103.192 114.214 103.192ZM111.99 98.264H116.182C116.182 97.8 116.105 97.3867 115.95 97.024C115.801 96.656 115.58 96.368 115.286 96.16C114.993 95.952 114.636 95.848 114.214 95.848C113.622 95.848 113.113 96.04 112.686 96.424C112.265 96.808 112.033 97.4213 111.99 98.264Z"
      fill="#2C3236"
      className="dark:fill-caption"
    />
  </svg>
);
export default ProgramNoData;
